import {ModuleWithProviders, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListNotesComponent } from './list-notes/list-notes.component';
import { EditNoteComponent } from './edit-note/edit-note.component';
import { NotesComponent } from './notes.component';
import {MenuService} from '../menu/menu.service';
import {RouterModule} from '@angular/router';
import {notesRoutes} from './notes.routes';
import {SharedModule} from '../shared/shared.module';
import { EditorComponent } from '../shared/editor/editor.component';
import {FormsModule} from '@angular/forms';
import {TagsModule} from '../tags/tags.module';
import { ViewNoteComponent } from './view-note/view-note.component';
import {DashboardService} from '../dashboard.service';
import {ApiService} from '../api.service';
import {SearchService} from '../search/search.service';
import {SearchResult, SearchResultItem} from '../search/interface.search';

const routing: ModuleWithProviders = RouterModule.forRoot(notesRoutes);

@NgModule({
  imports: [
      SharedModule,
      FormsModule,
      TagsModule,
      // EditorComponent,
    CommonModule,
      routing
  ],
  declarations: [ListNotesComponent, EditNoteComponent, NotesComponent, ViewNoteComponent]
})
export class NotesModule {
  constructor(
      protected menuService: MenuService,
      private dashboardService: DashboardService,
      private apiService: ApiService,
      private searchService: SearchService) {
      this.menuService.addMenuItems(
          [
              {
                  name: 'notes',
                  path: '/notes',
                  icon: 'fas fa-pen-square',
                  children: [
                      {
                          name: 'list',
                          path: '/notes/list'
                      },
                      {
                          name: 'new',
                          path: '/notes/new'
                      }
                  ]
              }]
      );
      this.dashboardService.fetchItems.subscribe((val) => {
          this.dashboardService.addDashboardItem(
              'notes',
              {title: 'Notes',
                  items: [],
                  footer: {text: '', buttons: []},
                  icon: 'fas fa-pen-square'}
                  );
          this.apiService.getAll('notes').subscribe(
              (value: any) => {
                  value.sort((a, b) => {
                      return b['added'] > a['added'] ? 1 : -1;
                  });
                  value.length = Math.min(value.length, 10);
                  const dashboardItems: SearchResult = {
                      title: 'Latest Notes',
                      items: [],
                      footer: {text: '', buttons: [
                          {link: '/notes', linkText: 'All notes', icon: 'fas fa-pen-square'},
                              {link: '/notes/new', linkText: 'New note', icon: 'fas fa-plus-circle'},
                          ]},
                      icon: 'fas fa-pen-square'
                  };
                  for (let a = 0; a < value.length; a++) {
                      const item = value[a];
                      const added = new Date(item.added);
                      const label = item.title +
                          ', added on: ' + added.toDateString();
                      const resultItem = {
                          label: label,
                          routerLink: ['/notes/view/', item._id],
                          link: ''
                      };
                      dashboardItems.items.push(resultItem);
                  }
                  if (value.length === 0) {
                      dashboardItems.footer.text = 'No notes added yet';
                  }
                  this.dashboardService.addDashboardItem('notes', dashboardItems);
              }
          );
      });
      this.searchService.getSearchTermSubject().subscribe((val) => {
          this.searchService.addSearchResult('links',
              {
                  title: 'Fetching search results for notes ...',
                  items: [],
                  footer: {text: '', buttons: [{link: '/notes', linkText: 'All notes'}]},
                  icon: 'fas fa-pen-square'
              });
          this.apiService.search('notes', val).subscribe(
              (value: Array<any>) => {
                  const searchResult: SearchResult = {
                      title: 'Notes',
                      items: [],
                      footer: {text: '', buttons: [{link: '/notes', linkText: 'All notes'}]},
                      icon: 'fas fa-pen-square'
                  };
                  for (const item of value) {
                      const added = new Date(item.added);
                      const label = item.title +
                          ', added on: ' + added.toDateString();
                      const resultItem = {
                          label: label,
                          routerLink: ['/notes/view/', item._id],
                          link: ''
                      };
                      searchResult.items.push(resultItem);
                  }
                  if (value.length === 0) {
                      searchResult.footer.text = 'No results found';
                  }
                  this.searchService.addSearchResult('notes', searchResult);
              });
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/notes/notes.module.ts